
import { TikTokAuthor } from "@/types/api";

export const getAuthorDisplayName = (author: string | TikTokAuthor): string => {
  if (typeof author === 'string') {
    return author;
  }
  return author.uniqueId || author.nickname || "Unknown creator";
};

export function formatDuration(seconds: number) {
  if (isNaN(seconds) || seconds <= 0) return "0s";
  if (seconds < 60) return `${seconds}s`;
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}m${sec < 10 ? "0" : ""}${sec}s`;
}

export function getAuthorProfileUrl(author: string | TikTokAuthor): string {
  const username = getAuthorDisplayName(author);
  return `https://www.tiktok.com/@${username}`;
}

export function formatVideoCount(count: number): string {
  if (count === 0) return "No videos";
  if (count === 1) return "1 video";
  return `${count} videos`;
}

export function formatTimeElapsed(startTime: number): string {
  const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
  
  if (elapsedSeconds < 60) {
    return `${elapsedSeconds}s`;
  } else if (elapsedSeconds < 3600) {
    const minutes = Math.floor(elapsedSeconds / 60);
    const seconds = elapsedSeconds % 60;
    return `${minutes}m ${seconds}s`;
  } else {
    const hours = Math.floor(elapsedSeconds / 3600);
    const minutes = Math.floor((elapsedSeconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  }
}

export function calculateVideoStats(videos: any[]) {
  if (!videos || videos.length === 0) {
    return {
      totalVideos: 0,
      totalDuration: 0,
      avgDuration: 0,
      formattedTotalDuration: '0s',
      formattedAvgDuration: '0s'
    };
  }
  
  const totalDuration = videos.reduce((sum, video) => {
    const duration = Number(video.duration) || 0;
    return sum + duration;
  }, 0);
  
  const avgDuration = totalDuration / videos.length;
  
  return {
    totalVideos: videos.length,
    totalDuration,
    avgDuration,
    formattedTotalDuration: formatDuration(totalDuration),
    formattedAvgDuration: formatDuration(avgDuration)
  };
}
